import { Enumify } from "enumify-ts";
class InvoiceTerms extends Enumify() {
    description;
    static SEVEN_DAYS = new InvoiceTerms("7 Days");
    static FOURTEEN_DAYS = new InvoiceTerms("14 Days");
    static THIRTY_DAYS = new InvoiceTerms("30 Days");
    static LAST_DAY_OF_MONTH = new InvoiceTerms("Last day of the month");
    static LAST_DAY_OF_NEXT_MONTH = new InvoiceTerms("Last day of next month");
    static LAST_DAY_OF_MONTH_PLUS_TWO_MONTHS = new InvoiceTerms("2 months from last day of the month");
    static _ = InvoiceTerms._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
    static selectOptionsArray() {
        return InvoiceTerms.values.map(r => {
            return {
                label: r.description,
                value: r.key
            };
        });
    }
}
export default InvoiceTerms;
